module.exports = __webpack_public_path__ + "img/Project-2.4a68958.png";